import { EvaluationsModel } from "../EvaluationsModel";
import { ImagesModel } from "./ImagesModel";

export class EventWorldModel{
    id?: number;
    images?:string;
    titleAr?:string;
    titleEn?:string;
    titleFr?:string;
    descriptionAr?:string;
    descriptionEn?:string;
    descriptionFr?:string;
    latitude?:  number;
    longitude?: number;
    countryId?: number;
    cityId?: number;
    userId?: number;
    date?: Date;
    eventImagesList?:ImagesModel[]

    cityNameAr?:string;
    cityNameEn?:string;
    countryNameAr?:string;
    countryNameEn?:string;
    
    averageStar?: number;
    

    constructor(item?:EventWorldModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.images = item.images? item.images:'';
        this.titleAr = item.titleAr? item.titleAr:'';
        this.titleEn = item.titleEn? item.titleEn:'';
        this.titleFr = item.titleFr? item.titleFr:'';
        this.descriptionAr = item.descriptionAr? item.descriptionAr:'';
        this.descriptionEn = item.descriptionEn? item.descriptionEn:'';
        this.descriptionFr = item.descriptionFr? item.descriptionFr:'';
        this.latitude = item.latitude? item.latitude:0;
        this.longitude = item.longitude? item.longitude:0;
        this.countryId = item.countryId? item.countryId:0;
        this.cityId = item.cityId? item.cityId:0;
        this.userId = item.userId? item.userId:0;
        this.date = item.date? item.date:new Date();
        this.eventImagesList = item.eventImagesList? item.eventImagesList:[];
        this.cityNameAr = item.cityNameAr? item.cityNameAr:'';
        this.cityNameEn = item.cityNameEn? item.cityNameEn:'';
        this.countryNameAr = item.countryNameAr? item.countryNameAr:'';
        this.countryNameEn = item.countryNameEn? item.countryNameEn:'';
        
        this.averageStar = item.averageStar? item.averageStar:0;

    }

}